import { PreviewSizes } from "./usePreviewResize";
import { useFitToPanelSize } from "./useFitToPanelSize";
import { SCENES_HORIZONTAL_PADDING, SCENES_TOP_RESERVE } from "../constants";

export type ScenesFit = {
  /** Largest preview box of the scene aspect ratio that fits the viewport. */
  previewSize: { width: number; height: number };
  /** Height of a single snap page (viewport height minus the reserved top). */
  pageHeight: number;
};

/**
 * Fits the largest box of the preview's aspect ratio into the actual scenes
 * scroll viewport, falling back to the window-based preview size until the
 * viewport is measured. Shared by the chapter- and slide-based scene editors so
 * both feed the same computed size to templates, toolbar and menu, keeping item
 * position math aligned.
 */
export const useScenesFit = (
  scrollEl: HTMLElement | null,
  previewSizes: PreviewSizes
): ScenesFit => {
  const aspectRatio =
    previewSizes.scene.height > 0
      ? previewSizes.scene.width / previewSizes.scene.height
      : 1;
  const fit = useFitToPanelSize(
    scrollEl,
    aspectRatio,
    SCENES_TOP_RESERVE,
    SCENES_HORIZONTAL_PADDING
  );
  return {
    previewSize: fit.size.width > 0 ? fit.size : previewSizes.scene,
    pageHeight: fit.pageHeight > 0 ? fit.pageHeight : previewSizes.scene.height,
  };
};
